import React from "react";
import Slider from "react-slick";
import get from "lodash/get";
import format from 'date-fns/format'
import { Link, ResponsiveHeroImage, ReviewRating} from "@quintype/components";
import { ImageFallback } from "../image-fallback.js";
import { SectionName } from "../section-name.js";

import TimeAgo from 'react-timeago';
import './full-screen-slider.module.css';
import arabicStrings from "react-timeago/lib/language-strings/ar";
import buildFormatter from "react-timeago/lib/formatters/buildFormatter";
import { wrapCollectionLayout } from "@quintype/components";
import {collectionSection} from '../../collection-templates/collection-layout-helper';
import { DotIcon } from '../dot-icon.js';
import { breakpoint } from "../../../../utils/breakpoint";
import {getNumberOfStoriesToShow} from "../../../utils";

export function Carousel(props) {
  const {
    metadata: {
      'slider_type_dots':sliderTypeDots = false,
      'slider_type_dashes':sliderTypeDashes = false,
      'set_scroll_speed':scrollSpeed = 500,
      'number_of_slides_to_show':slidesToShow = 1,
      'number_of_slides_to_scroll':slidesToScroll = 1,
      'show_arrows': showArrows = true,
      'enable_auto_play': autoplay = true,
      'show_collection_name': collectionName = true
    } = {}} = props;

  let {
    metadata: {
      'number_of_stories_to_show': numberOfStoriesToShow,
    } = {}
  } = props;

  numberOfStoriesToShow = getNumberOfStoriesToShow(numberOfStoriesToShow);

  const slidesOnMobile = breakpoint('mobile') ? 1  : parseInt(slidesToShow) ;
  const sliderPropObject = {
    dots: (sliderTypeDots || sliderTypeDashes),
    speed: (scrollSpeed && scrollSpeed > 0) ? scrollSpeed : 500,
    rtl: get(props.config, ['theme-attributes', 'language_direction']) === 'right',
    arrows: showArrows,
    slidesToShow:(slidesOnMobile && slidesOnMobile > 0) ? slidesOnMobile : 1,
    slidesToScroll:(slidesToScroll && parseInt(slidesToScroll) > 0) ? parseInt(slidesToScroll) : 1,
    autoplay:autoplay,
    dotsClass: sliderTypeDashes ? 'dashpaging' : 'slick-dots'
  };

  return (<div styleName="full-screen-slider-wrapper">
    {collectionName ? <SectionName  hideLink={true} name={props.collection.name} type="large" section={collectionSection(props.config, props.collection)}/> : null}
    <div styleName={`full-screen-slider ${get(props.config, ['theme-attributes', 'language_direction']) === 'right' ? 'dots-rtl' : ''}`}>
      <Slider {...sliderPropObject}>
        {props.stories.slice(0, numberOfStoriesToShow || 6).map((story) => {
            return <div key={story.id}>
              <CarouselItem metadata={props.metadata} story={story} config={props.config} collection={props.collection}/>
            </div>
          }
        )}
      </Slider>
    </div>
  </div>);
}

Carousel.defaultProps = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  numberOfStoriesToShow: 6
};

function CarouselItem(props) {
  if(!props.story) {
    return null;
  }
  return <Link href={"/" + props.story.slug}>
    <Slide metadata={props.metadata} config={props.config} story={props.story} collection= {props.collection}/>
  </Link>
}


function Slide(props) {

  const {
    metadata: {
      'show_section_tag': showSectionTag = true,
      'show_collection_title': showCollectionTitle = true,
      'show_author_name':showAuthorName = true,
      'show_time_of_publish': showTimeOfPublish = true,
      'full_width_container': fullWidthContainer = true,
      'number_of_slides_to_show': numberOfStoriesToShow = 1
    } = {}} = props;
  const responsiveFigure = <figure styleName={props.story['story-template'] === 'video' ? 'video' : ''}>

    <ResponsiveHeroImage story={props.story}
                         aspectRatio={[3,1]}
                         defaultWidth={1024} widths={[640,1024,1280]}
                         imgParams={{auto:['format', 'compress'], fit:'max'}}/>
  </figure>;

  const heroImageTemplate = props.story["hero-image-s3-key"] ? responsiveFigure : <ImageFallback />;
  const isReviewStory = props.story["story-template"] === 'review';
  return <div styleName={`full-screen-slider-slide ${fullWidthContainer ? 'full-screen-slider-fullWidth' : 'full-screen-slider-containerWidth'}`}>
    <div styleName="slide-image">
      {heroImageTemplate}
    </div>
    <div styleName="content">
      {showSectionTag ? <div styleName="section">{get(props.story, ['sections', 0, 'display-name']) || get(props.story, ['sections', 0, 'name'], '')}</div> : null }
      <div styleName={`title ${numberOfStoriesToShow > 2 ? 'title-font-small': 'title-font-big' }`} dangerouslySetInnerHTML={ {__html: props.story.headline }}></div>
      {isReviewStory && <ReviewRating value={get(props.story, ['metadata','review-rating', 'value'], '0')} />}
      <div styleName="created-at">
        {showAuthorName ? <div> BY {get(props.story, ['authors', 0, 'name'], props.story['author-name'])} </div> : null }
        {showAuthorName  && showTimeOfPublish ? <DotIcon fill='#fff'/> : null }
        {showTimeOfPublish ? <div><TimeAgo date={props.story['first-published-at']} suffix='from now'/></div> : null }
      </div>
    </div>
  </div>

}


function formatter(value, unit, suffix, date, defaultFormatter, config = {}) {
  const _formatter =  buildFormatter(arabicStrings);
  return _formatter.apply(this, [value, unit, suffix, date]);
}